module.exports = __webpack_public_path__ + "static/img08-1c75b2db2c7707f276e84de786f49d8d.jpg";